import {HTMLAttributes} from 'react';
import {Condition, useFormatDate} from '@legit.health/ui';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Chip from '@mui/material/Chip';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import {useTranslation} from 'react-i18next';
import useLocale from '@/shared/hooks/useLocale';
import ConditionAvatar from './ConditionAvatar';

export default function ConditionSelectItem({
  condition,
  className,
  liProps
}: {
  condition: Condition;
  className?: string;
  liProps?: HTMLAttributes<HTMLLIElement>;
}) {
  const {t} = useTranslation(['shared/common']);
  const locale = useLocale();
  const formatDate = useFormatDate(locale);

  return (
    <ListItem
      data-testid={`${condition.pathology.code.replaceAll(' ', '_')}-${condition.bodySite.code}-option`}
      divider
      className={className}
      {...liProps}
    >
      <ListItemAvatar>
        <ConditionAvatar condition={condition} />
      </ListItemAvatar>

      <ListItemText
        sx={{
          my: 0
        }}
        primary={condition.pathology.name}
        secondary={
          <>
            <Chip
              component="span"
              size="small"
              label={condition.bodySite.name}
              color="secondary"
              variant="outlined"
              icon={<AccessibilityIcon />}
              sx={{
                mr: 1
              }}
            />
            <Chip
              component="span"
              size="small"
              label={
                condition.isTracked
                  ? t('shared/common:followUp')
                  : t('shared/common:followUpPaused')
              }
              color="secondary"
              variant="outlined"
              icon={condition.isTracked ? <VisibilityIcon /> : <VisibilityOffIcon />}
            />
            <Typography
              variant="body2"
              component="span"
              sx={{
                display: {
                  xs: 'none',
                  lg: 'block'
                }
              }}
              display="inline"
            >
              {formatDate(condition.createdAt)}
            </Typography>
          </>
        }
      />
    </ListItem>
  );
}
